<template>
  <div
    class="generic-touchpoint__text"
    :class="{ 'generic-touchpoint__text--double': isDouble }"
    ref="touchpointText">
    {{ content }}
  </div>
</template>
<script lang="ts">
import {
  Vue, Component, Prop, Ref
} from 'vue-property-decorator';

@Component
export default class GenericTouchPointTextComponent extends Vue {
  @Prop({ default: null })
  public content!: string;

  @Ref('touchpointText')
  public readonly touchpointText!: HTMLDivElement;

  public isDouble: boolean = false;

  public updateContainerSize() {
    if (!this.isDouble && this.touchpointText.clientHeight >= 62) {
      this.isDouble = true;
    } else if (this.isDouble && this.touchpointText.clientHeight <= 36) {
      this.isDouble = false;
    }
  }

  public beforeDestroy() {
    window.removeEventListener('resize', this.updateContainerSize);
  }

  public mounted() {
    this.updateContainerSize();
    window.addEventListener('resize', this.updateContainerSize);
  }
}
</script>
